import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client'
import fetch from 'cross-fetch'

import { headersWithToken } from '../api/apiHelper'
import { Datadog } from '../Global/Datadog'
import { isSessionTokenExpired } from '../reducers/token'
import { logout } from '../utils'

const sessionTokenMiddleware = new ApolloLink((operation, forward) => {
  // When a session expires, but the UI still lives in the browser, the next
  // action that call the API will fail and it's better to log out a user
  // rather than to allow an Oops page or a limbo with missing data in the state.
  if (isSessionTokenExpired()) {
    Datadog.addAction('logout', { reason: 'Session token expired' })
    logout()
  }

  return forward(operation)
})

export const restInvoiceClient = new ApolloClient({
  link: ApolloLink.from([
    sessionTokenMiddleware,
    new HttpLink({
      uri: '/rest-invoice/graphql',
      headers: headersWithToken(),
      fetch,
    }),
  ]),
  cache: new InMemoryCache(),
})

export const documentReportsClient = new ApolloClient({
  link: ApolloLink.from([
    sessionTokenMiddleware,
    new HttpLink({
      uri: '/document-reports/graphql',
      headers: headersWithToken(),
      fetch,
    }),
  ]),
  cache: new InMemoryCache(),
})
